import {
  TableRow,
  TableCell,
} from "styles/devices/deviceDetails.styles";
import { ParamSetPointCell } from "./params/ParamSetPointCell";
import { ParamConnectionCell } from "./params/ParamConnectionCell";

interface VsdStatusRowProps {
  currentValue: string | number | null;
  isConnected: boolean;
  pendingValue: number;
  pendingConnected: boolean;
  isEditing: boolean;
  disabled?: boolean;
  disabledMessage?: string;
  onValueChange: (value: number) => void;
  onConnectionToggle: () => void;
}

const VSD_OPTIONS = [2, 4, 6, 8, 10].map((value) => ({
  label: value.toString(),
  value,
}));

export function VsdStatusRow({
  currentValue,
  isConnected,
  pendingValue,
  pendingConnected,
  isEditing,
  disabled,
  disabledMessage = "",
  onValueChange,
  onConnectionToggle,
}: VsdStatusRowProps) {
  return (
    <TableRow connected={isEditing ? pendingConnected : isConnected}>
      <TableCell>
        <strong>VSD</strong>
      </TableCell>
      <TableCell>
        <span>{currentValue || "N/A"}</span>
      </TableCell>
      <TableCell>
        <ParamSetPointCell
          value={pendingValue || currentValue}
          pendingValue={pendingValue}
          isEditing={isEditing}
          disabled={disabled}
          disabledMessage={disabledMessage}
          options={VSD_OPTIONS}
          inputId="vsd-setpoint"
          onValueChange={onValueChange}
        />
      </TableCell>
      <TableCell>
        <ParamConnectionCell
          isConnected={isConnected}
          pendingConnected={pendingConnected}
          isEditing={isEditing}
          disabled={disabled}
          disabledMessage={disabledMessage}
          switchId="vsd-connection"
          onToggle={onConnectionToggle}
        />
      </TableCell>
    </TableRow>
  );
}
